import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let pending = [];
let timer = null;

const flush = () => {
  if (!pending.length) return;
  const body = JSON.stringify({ events: pending.splice(0, 40) });
  try { navigator.sendBeacon(`${API}/heat/batch`, new Blob([body], { type: "application/json" })); }
  catch { fetch(`${API}/heat/batch`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {}); }
};

const sectionName = (el) =>
  el.getAttribute("data-heat") || el.id ||
  (el.querySelector("h1,h2,h3")?.textContent || "").trim().slice(0, 60) || el.tagName.toLowerCase();

export const HeatTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (/^\/(teamportal|clientportal|admin|login)/.test(location.pathname)) return undefined;
    const path = location.pathname;
    const seen = new Map();
    const io = new IntersectionObserver((entries) => {
      const now = Date.now();
      entries.forEach((en) => {
        const key = sectionName(en.target);
        if (!key) return;
        if (en.isIntersecting) seen.set(key, { start: now, ...seen.get(key), started: now });
        else if (seen.get(key)?.started) {
          const rec = seen.get(key);
          pending.push({ path, section: key, dwell_ms: now - rec.started });
          seen.set(key, { ...rec, started: null });
        }
      });
    }, { threshold: 0.4 });
    const attach = () => document.querySelectorAll("main section, [data-heat]").forEach((el) => io.observe(el));
    const t = setTimeout(attach, 1200);
    timer = setInterval(flush, 15000);
    const onHide = () => {
      const now = Date.now();
      seen.forEach((rec, key) => { if (rec.started) pending.push({ path, section: key, dwell_ms: now - rec.started }); });
      flush();
    };
    window.addEventListener("pagehide", onHide);
    return () => {
      clearTimeout(t); clearInterval(timer); io.disconnect();
      onHide(); window.removeEventListener("pagehide", onHide);
    };
  }, [location.pathname]);
  return null;
};
